export const CONSULTATION_TYPES = [
  { code: 'service_development', label: '新規サービス開発支援' },
  { code: 'service_improvement', label: '既存サービスの改善' },
  { code: 'corporate_site', label: 'コーポレートサイト制作' },
  { code: 'global_site', label: 'グローバルサイト制作' },
  { code: 'owned_media', label: 'オウンドメディア制作' },
  { code: 'solution_inquiry', label: '弊社ソリューションについて' },
  { code: 'consulting', label: '各種コンサルティング' },
  { code: 'recruitment', label: '採用について' },
  { code: 'redesign_labo', label: 'AI共創型 システムリデザインラボ' },
  { code: 'sales_proposal', label: '営業・提案について' },
  { code: 'document_request', label: '資料請求' },
  { code: 'other', label: 'その他' }
];

export function validateContactForm(formData) {
  const { name, company, tel, mail, subject, contact_content } = formData;
  const errors = {};

  if (!name || name.trim() === '') {
    errors.name = 'お名前は必須です';
  } else if (name.length > 50) {
    errors.name = 'お名前は50文字以内で入力してください';
  }

  if (!company || company.trim() === '') {
    errors.company = '会社名は必須です';
  } else if (company.length > 100) {
    errors.company = '会社名は100文字以内で入力してください';
  }

  if (!tel || tel.trim() === '') {
    errors.tel = '電話番号は必須です';
  } else {
    const phoneRegex = /^(\+\d{1,3}[-.\s]?)?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{0,4}$/;
    if (!phoneRegex.test(tel.replace(/\s/g, ''))) {
      errors.tel = '正しい電話番号の形式で入力してください';
    }
  }

  if (!mail || mail.trim() === '') {
    errors.mail = 'メールアドレスは必須です';
  } else if (mail.length > 100) {
    errors.mail = 'メールアドレスは100文字以内で入力してください';
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(mail)) {
      errors.mail = '正しいメールアドレスの形式で入力してください';
    }
  }

  if (!subject || subject === '' || subject === '以下の項目より選択してください') {
    errors.subject = 'ご相談内容を選択してください';
  } else if (!CONSULTATION_TYPES.find(t => t.code === subject)) {
    errors.subject = '有効なご相談内容を選択してください';
  }

  if (!contact_content || contact_content.trim() === '') {
    errors.contact_content = 'お問い合わせ内容は必須です';
  } else if (contact_content.length > 5000) {
    errors.contact_content = 'お問い合わせ内容は5000文字以内で入力してください';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
}

export function validateRequiredFields(formData) {
  const { name, company, tel, mail, subject, contact_content } = formData;
  return !!(name && company && tel && mail && subject && contact_content);
}
export function getLabelFromCode(code) {
  const type = CONSULTATION_TYPES.find(t => t.code === code);
  return type ? type.label : code;
}
